import { WorkoutTemplate } from "../models/Workout";
import { legDay, newUpperBodyDay } from "./other-workouts";
import { pullDay, pushDay } from "./tom-workouts";

export const DEFAULT_WORKOUTS: WorkoutTemplate[] = [
  legDay,
  newUpperBodyDay,
  pushDay,
  pullDay,
]
